import { useContext, useMemo, useEffect, createContext } from 'react';
import { useUniqueId } from '../utils/unique-id.js';
export const FocusManagerContext = createContext(undefined);
export function useFocusManager({ trapping }) {
    const focusManager = useContext(FocusManagerContext);
    const id = useUniqueId('Focus');
    if (!focusManager) {
        throw new Error('No FocusManager was provided.');
    }
    const { trapFocusList, add: addFocusItem, remove: removeFocusItem, } = focusManager;
    const canSafelyFocus = trapFocusList[0] === id;
    const value = useMemo(() => ({ canSafelyFocus }), [canSafelyFocus]);
    useEffect(() => {
        if (!trapping) {
            return;
        }
        addFocusItem(id);
        return () => {
            removeFocusItem(id);
        };
    }, [addFocusItem, id, removeFocusItem, trapping]);
    return value;
}
//# sourceMappingURL=useFocusManager.js.map